/**
 * Shared PrimeVue Dialog pass-through for CRC form modals.
 * Visual shell: rounded-2xl, zero-padding header/content, section borders in slots.
 */

export const CRC_FORM_DIALOG_ROOT_CLASS = 'crc-form-dialog overflow-hidden rounded-2xl shadow-xl';

export const CRC_DRILL_DIALOG_ROOT_CLASS =
  'crc-form-dialog crc-drill-dialog overflow-hidden rounded-xl shadow-xl';

/**
 * @param {{ scrollable?: boolean }} [options]
 */
export function buildCrcFormDialogPt(options = {}) {
  const scrollable = options.scrollable !== false;

  return {
    root: { class: CRC_FORM_DIALOG_ROOT_CLASS },
    header: {
      class: '!p-0 border-b border-surface-200 dark:border-surface-700 shrink-0',
    },
    content: {
      class: scrollable
        ? '!p-0 overflow-y-auto max-h-[min(70vh,640px)]'
        : '!p-0',
    },
    footer: {
      class: '!p-0 border-t border-surface-200 dark:border-surface-700 shrink-0',
    },
  };
}

export const crcFormDialogPt = buildCrcFormDialogPt();

export const crcFormDialogPtNoScroll = buildCrcFormDialogPt({ scrollable: false });

export const crcDrillDialogPt = {
  root: { class: CRC_DRILL_DIALOG_ROOT_CLASS },
  header: {
    class: '!p-0 border-b border-surface-200 dark:border-surface-700 shrink-0',
  },
  content: {
    class: 'px-6 py-4 overflow-y-auto max-h-[min(75vh,720px)]',
  },
  footer: {
    class: '!p-0 border-t border-surface-200 dark:border-surface-700 shrink-0',
  },
};
